import { useQuery } from '@tanstack/react-query';

import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import type { AxiosErrorResponse, BaseReportsPaginated, BaseReportsPaginatedResponse, PaginatedData } from '@/types';

export type ListAllKimPpDTO = BaseReportsPaginated;

export type ListAllKimPpResponse = PaginatedData<BaseReportsPaginatedResponse>;

async function listKimPpPaginated(params: ListAllKimPpDTO): Promise<ListAllKimPpResponse> {
	const url = '/ergonomic-tool/kim-pp/reports/list-all';
	const { data } = await Api.get<ListAllKimPpResponse>(url, {
		params
	});
	return data;
}

export const useListKimPpPaginated = ({
	limit,
	offset,
	sector_id,
	company_id,
	cellule_id,
	report_name,
	activity_id,
	evaluator_id,
	original_name,
	created_at_end,
	workstation_id,
	organization_id,
	created_at_start,
	isSelectedReport
}: ListAllKimPpDTO) => {
	const enabled = !!limit && !!isSelectedReport && offset >= 0;
	const kimPpReport = useQuery<ListAllKimPpResponse, AxiosErrorResponse>(
		[
			QUERY_KEYS.GET_KIM_PP_REPORTS_PAGINATED,
			[
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			]
		],
		() =>
			listKimPpPaginated({
				limit,
				offset,
				sector_id,
				company_id,
				cellule_id,
				report_name,
				activity_id,
				evaluator_id,
				original_name,
				created_at_end,
				workstation_id,
				organization_id,
				created_at_start
			}),
		{
			enabled,
			retry: 0
		}
	);
	return kimPpReport;
};
